module.exports = __webpack_public_path__ + "img/awards.06a4ecf.jpg";